import { render, staticRenderFns } from "./ShipmentSuccess.vue?vue&type=template&id=fa0dcab6&scoped=true"
import script from "./ShipmentSuccess.vue?vue&type=script&lang=ts"
export * from "./ShipmentSuccess.vue?vue&type=script&lang=ts"
import style0 from "./ShipmentSuccess.vue?vue&type=style&index=0&id=fa0dcab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0dcab6",
  null
  
)

export default component.exports